module.exports = __webpack_public_path__ + "static/media/check.0b437879.svg";